import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dialog-custom__title mb-0" }
const _hoisted_2 = { class: "fs-18 text-gray" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { style: {"height":"calc(100vh - 330px)"} }
const _hoisted_5 = {
  class: "p-selectbutton--blocks p-2",
  style: {"--cols":"6"}
}
const _hoisted_6 = { class: "bt-icon text-gray" }
const _hoisted_7 = { class: "mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_NumberButtons = _resolveComponent("NumberButtons")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", {
      "data-plant": _ctx.$attrs.plantId,
      class: "dialog-custom__header"
    }, [
      _createVNode("h1", _hoisted_1, _toDisplayString(_ctx.stepTitle), 1),
      _createVNode("p", _hoisted_2, _toDisplayString(_ctx.stepSubTitle), 1)
    ], 8, ["data-plant"]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_ElScrollbar, null, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_5, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.roomTypes, (roomType) => {
                return (_openBlock(), _createBlock("div", {
                  key: roomType.type,
                  class: "p-button text-primary"
                }, [
                  _createVNode("span", _hoisted_6, [
                    _createVNode(_component_InlineSvgScoped, {
                      src: 
                                    require(`@/assets/images/icons/${_ctx.getRoomIcon(roomType.type)}.svg`)
                                
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("p", _hoisted_7, _toDisplayString(roomType.label), 1),
                  _createVNode(_component_NumberButtons, {
                    modelValue: roomType.count,
                    "onUpdate:modelValue": ($event: any) => (roomType.count = $event),
                    onInput: ($event: any) => (_ctx.updatePlantRoom(roomType))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}